module.exports = __webpack_public_path__ + "catalog/items/bathroom/fancy-bathroom-sink/fancy-bathroom-sink.svg";